/* tslint:disable */

// Partly Generated using typescript-generator version 2.16.538 on 2019-08-23 11:56:53.

export interface CodeValuePair {
  code: string
  value: string
}

export type ContactType = TelephoneContactType | EmailContactType

export interface Contact {
  '@type': 'TelephoneContact' | 'EmailContact'
  contactType: ContactType
  usageCategory: UsageCategory
}

export type ContactUnion = EmailContact | TelephoneContact

export enum DataLineLabelKeys {
  Salutation = 'salutation',
  AcademicTitle = 'academicTitle',
  NobilityTitle = 'nobilityTitle',
  FirstName = 'firstName',
  LastName = 'lastName',
  NameAffix = 'nameAffix',
  DateOfBirth = 'dateOfBirth',
  StreetAndHouseNumber = 'streetAndHouseNumber',
  AdditionalToAddress = 'additionalToAddress',
  ZipcodeAndCity = 'zipcodeAndCity',
  Country = 'country',
  Emails = 'emails'
}

export interface EmailContact extends Contact {
  '@type': 'EmailContact'
  email: string
}

export enum EmailContactType {
  E // E-Mail
}

export interface LegalPerson extends PartnerProxyPerson {
  '@type': 'LegalPerson'
  foundingDate: Date
  companyForm: CodeValuePair
  industry: CodeValuePair
  employeeCount?: number
  sicKey: CodeValuePair
  name: LegalPersonName
}

export interface LegalPersonName {
  salutation: CodeValuePair
  name1: string
  name2: string
}

export interface NaturalPerson extends PartnerProxyPerson {
  '@type': 'NaturalPerson'
  birthdate?: string // "YYYY-MM-DD"
  nationality: CodeValuePair
  name: NaturalPersonName
}

export interface NaturalPersonName {
  salutation: CodeValuePair
  name: string
  firstName: string
  prefix: string
  suffix: string
  academicTitle: string
  nobilityTitle: string
  otherTitle: string
}

export interface PartnerProxyPartner {
  partnerAddresses: PartnerProxyPartnerAddress[]
  partnerId?: number
  person: PersonUnion
}

export interface PartnerProxyPartnerAddress {
  address: PostalAddressUnion
  contacts: ContactUnion[]
  partner?: PartnerProxyPartner
  partnerAddressId?: number
  partnerProxyIds: string[]
}

export interface PartnerProxyPerson {
  '@type': 'NaturalPerson' | 'LegalPerson'
}

export interface PhysicalAddress extends PostalAddress {
  '@type': 'PhysicalAddress'
  street: string
  streetExtra: string
  city: string
}

export interface PostOfficeBox extends PostalAddress {
  '@type': 'PostOfficeBox'
  postOfficeBoxNumber: string
  nameLine1: string
  nameLine2: string
}

export interface PostalAddress {
  '@type': 'PhysicalAddress' | 'PostOfficeBox'
  country: CodeValuePair
  postCode: string
}

export type PostalAddressUnion = PhysicalAddress | PostOfficeBox

export type PersonNameUnion = NaturalPersonName | LegalPersonName

export type PersonUnion = NaturalPerson | LegalPerson

export enum TelephoneContactType {
  T, // Telephone
  H, // Mobile Phone
  F // Fax
}

export interface TelephoneContact extends Contact {
  '@type': 'TelephoneContact'
  areaCode: string
  telephoneNumber: string
}

export enum UsageCategory {
  P, // Private
  G, // Commercial
  U // Unknown
}

/* The following was added by hand */
